/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Plan_BodyInputs */

const en_features_plan_body = /** @type {(inputs: Features_Plan_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercises from your library, sets, reps and load day by day. One click and the plan is with your client, ready to train.`)
};

const pl_features_plan_body = /** @type {(inputs: Features_Plan_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ćwiczenia z biblioteki, serie, powtórzenia i ciężar dzień po dniu. Jedno kliknięcie i plan jest u podopiecznego, gotowy do treningu.`)
};

/**
* | output |
* | --- |
* | "Exercises from your library, sets, reps and load day by day. One click and the plan is with your client, ready to train." |
*
* @param {Features_Plan_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_plan_body = /** @type {((inputs?: Features_Plan_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Plan_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_plan_body(inputs)
	return en_features_plan_body(inputs)
});